webpackJsonp([170384593892729],{

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resumepdf = 'https://github.com/dsmftw/resume/raw/master/ik-resume.pdf';
	var latexsrc = 'https://github.com/dsmftw/resume';
	
	var CVPage = function CVPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'R\xE9sum\xE9 / CV'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: resumepdf, download: true },
	        'Download'
	      ),
	      ' a copy of my r\xE9sum\xE9.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Also, feel free to explore its ',
	      _react2.default.createElement(
	        'span',
	        { className: 'latex' },
	        'L',
	        _react2.default.createElement(
	          'sup',
	          null,
	          'a'
	        ),
	        'T',
	        _react2.default.createElement(
	          'sub',
	          null,
	          'e'
	        ),
	        'X'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'nofollow', href: latexsrc },
	        'source code'
	      ),
	      ' on my GitHub repository.'
	    )
	  );
	};
	
	exports.default = CVPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cv-js-fd1c42568d8938683a1f.js